"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Button = _interopRequireDefault(require("@cimpress/react-components/lib/Button"));

var _core = require("@emotion/core");

var _excluded = ["shipRecRequest"];

var ViewDiagnosticsButton = function ViewDiagnosticsButton(_ref) {
  var shipRecRequest = _ref.shipRecRequest,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var encodedRequest = encodeURIComponent(JSON.stringify(shipRecRequest));
  var diagnosticsUrl = "https://shiprec.logistics.cimpress.io/configurationDiagnostics?r=".concat(encodedRequest);

  var onClick = function onClick(e) {
    e.stopPropagation();
  };

  return (0, _core.jsx)("div", {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, (0, _core.jsx)(_Button["default"], (0, _extends2["default"])({
    variant: "anchor",
    href: diagnosticsUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    onClick: onClick
  }, props), "View Diagnostics"));
};

ViewDiagnosticsButton.propTypes = {
  shipRecRequest: _propTypes["default"].object.isRequired
};
var _default = ViewDiagnosticsButton;
exports["default"] = _default;